import React from 'react'
import { withRouter } from 'react-router-dom'

import { Toast } from 'primereact/toast'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { TabView, TabPanel } from 'primereact/tabview';
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { AuthContext } from '../../main/ProvedorAutenticacao'

import NavBar from '../../componentes/Navbar'

import GrupoTarefaService from '../../app/service/GrupoTarefaService'
import TarefaService from '../../app/service/TarefaService'
import UsuarioService from '../../app/service/UsuarioService'

class GrupoTarefa extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      codigo: '',
      grupo: null,
      tarefasGrupos: [],
      tarefasSemGrupo: [],
      tarefaSemGrupo: null,
      nome: '',
      status: '',
      grupos: [],
      gruposTarefas: [],
      gruposTarefasSelecionar: [],
      grupoTarefa: null,
      openSpinner: false,
      modalGrupo: false,
      modalTarefasPorGrupo: false,
      modalGrupoAlterar: false,
      //Tarefas
      tarefas: [],
      tarefa: null,
      statusTarefa: null,
      nomeTarefa: '',
      codigoTarefa: '',
      modalTarefa: false,
      modalTarefaAlterar: false,
      prazo: '',
      tempo: null,
      pontuacao: '',
      responsaveis: [],
      usuarios: [],
      usuario: null,
      usuariosTarefa: [],
      modalCadastroUsuarios: false,
      modalAssociarGrupoTarefa: false,
      codigoExcluirAgrupamentoTarefa: '',
      modalAlterarTarefa: false,
      codigoUsuarioTarefa: ''
    }

    this.grupoTarefaService = new GrupoTarefaService();
    this.tarefaService = new TarefaService();
    this.usuarioService = new UsuarioService();

    this.acoesGrupos = this.acoesGrupos.bind(this);
    this.renderFooterGrupo = this.renderFooterGrupo.bind(this);
    this.renderFooterGrupoAlterar = this.renderFooterGrupoAlterar.bind(this);
    this.acoesUsuariosDesignados = this.acoesUsuariosDesignados.bind(this);
    this.acoesTarefas = this.acoesTarefas.bind(this);
    this.renderFooterTarefa = this.renderFooterTarefa.bind(this);
    this.renderFooterCadastrarUsuario = this.renderFooterCadastrarUsuario.bind(this);
    this.onChangeGrupoTarefa = this.onChangeGrupoTarefa.bind(this);
    this.acoesGruposAssociar = this.acoesGruposAssociar.bind(this);
    this.renderFooterAssosciarGrupoTarefa = this.renderFooterAssosciarGrupoTarefa.bind(this);
    this.acoesAgrupamentoTarefa = this.acoesAgrupamentoTarefa.bind(this);
    this.acceptRetirarAgrupamentoTarefa = this.acceptRetirarAgrupamentoTarefa.bind(this);
    this.acceptRetirarAgrupamentoTarefaPorGrupo = this.acceptRetirarAgrupamentoTarefaPorGrupo.bind(this);
    this.acoesTarefasPorGrupo = this.acoesTarefasPorGrupo.bind(this);
    this.onChangeTarefa = this.onChangeTarefa.bind(this);
    this.renderFooterAlterarTarefa = this.renderFooterAlterarTarefa.bind(this);
    this.acceptExcluirUsuario = this.acceptExcluirUsuario.bind(this);
    this.acoesUsuariosTarefa = this.acoesUsuariosTarefa.bind(this);
    this.acceptExcluirTarefa = this.acceptExcluirTarefa.bind(this);
 
    this.status = [
      {codigo: 'ATIVO', nome: 'ATIVO'},
      {codigo: 'INATIVO', nome: 'INATIVO'}
    ];

    this.tempo = [
      {codigo: 'Progressiva', nome: 'Progressiva'},
      {codigo: 'Regressiva', nome: 'Regressiva'}
    ]
  }

  listarTarefasSemGrupo = async (grupo) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.tarefaService.listarTarefasSemGrupo(grupo.codigo, usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({tarefasSemGrupo: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Grupos de Tarefas', detail:`${this.state.detail}`, life: 4000});
      })
  }

  async listarUsuarios(tarefa){
    const usuarioLogado = this.context.usuarioAutenticado;
    this.setState({openSpinner: true});
    await this.consultarTarefa(tarefa);
    await this.listarGruposPorTarefa(tarefa);
    await this.listarUsuariosPorTarefa(tarefa);
    await this.usuarioService.listarUsuariosEmpresa(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({usuarios: response.data});
        this.listarGruposPorTarefa(tarefa);
        this.setState({usuario: null});
        this.setState({grupoTarefa: null});
        this.novoUsuario('modalCadastroUsuarios');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Grupos de Tarefas', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  async onChangeGrupoTarefa(e) {
    if(e.value != null) {
      this.setState({openSpinner: true});
      await this.setState({grupoTarefa: e.value});
      await this.adicionarGrupoTarefa();
      this.setState({openSpinner: false});
    }
  }

  async onChangeTarefa(e) {
    if(e.value != null) {
      this.setState({openSpinner: true});
      await this.setState({tarefaSemGrupo: e.value});
      await this.adicionarGrupoTarefaPorGrupo();
      this.setState({openSpinner: false});
    }
  }

  adicionarGrupoTarefa = async () => {
    const agrupa = {
      grupo: this.state.grupoTarefa,
      tarefa: this.state.tarefa
    }
    await this.tarefaService.adicionarTarefaGrupo(agrupa)
      .then(response => {
        this.listarGruposPorTarefa(this.state.tarefa);
        this.listarGruposTarefasSelecionar(this.state.tarefa);
        this.toast.show({severity:'success', summary: 'Tarefas', detail:'Tarefa associada ao Grupo com sucesso!', life: 4000});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Grupos de Tarefas', detail:`${this.state.detail}`, life: 4000});
      });
  }

  adicionarGrupoTarefaPorGrupo = async () => {
    const agrupa = {
      grupo: this.state.grupo,
      tarefa: this.state.tarefaSemGrupo
    }
    await this.tarefaService.adicionarTarefaGrupo(agrupa)
      .then(response => {
        this.consultarTarefasGrupoPosCadastro(this.state.grupo);
        this.toast.show({severity:'success', summary: 'Grupos de Tarefas', detail:'Tarefa adicionada com sucesso!', life: 4000});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Grupos de Tarefas', detail:`${this.state.detail}`, life: 4000});
      });
  }

  listarGruposPorTarefa = async (tarefa) => {
    await this.tarefaService.listarGruposPorTarefa(tarefa.codigo)
      .then(response => {
        this.setState({gruposTarefas: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Grupos de Tarefas', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarGruposTarefasSelecionar = async (tarefa) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.tarefaService.listarGruposSemTarefa(tarefa.codigo, usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({gruposTarefasSelecionar: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Grupos de Tarefas', detail:`${this.state.detail}`, life: 4000});
      })
  }

  async consultarGruposTarefa(tarefa) {
    this.setState({openSpinner: true});
    await this.consultarTarefa(tarefa);
    this.setState({grupoTarefa: null});
    await this.listarGruposPorTarefa(tarefa);
    await this.listarGruposTarefasSelecionar(tarefa);
    this.associarGrupoTarefa('modalAssociarGrupoTarefa');
    this.setState({openSpinner: false});
  }

  acoesAgrupamentoTarefa(rowData) {
    return(
      <React.Fragment>
        <Button icon="fa fa-solid fa-trash" className="p-button-rounded p-button-text"
                onClick={() => this.confirmaExclusaoAgrupamentoTarefa(rowData)} 
                tooltip="Retirar Agrupamento" 
                tooltipOptions={{position: 'top'}}/>
      </React.Fragment>
    );
  }

  confirmaExclusaoAgrupamentoTarefa(grupo) {
    this.setState({codigoExcluirAgrupamentoTarefa: grupo.codigo});
    confirmDialog({
        message: 'Deseja realmente retirar o agrupamento da tarefa?',
        header: 'Retirada de Agrupamento',
        icon: 'pi pi-question-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptRetirarAgrupamentoTarefa,
        reject: this.reject
    });
  }

  confirmaExclusaoAgrupamentoTarefaPorGrupo(tarefa) {
    this.setState({codigoExcluirAgrupamentoTarefa: tarefa.codigo});
    confirmDialog({
        message: 'Deseja realmente retirar a tarefa deste grupo?',
        header: 'Retirada de Tarefa',
        icon: 'pi pi-question-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptRetirarAgrupamentoTarefaPorGrupo,
        reject: this.reject
    });
  }

  async acceptRetirarAgrupamentoTarefa() {
    this.setState({openSpinner: true});
    await this.tarefaService.excluirAgrupamento(this.state.tarefa.codigo,this.state.codigoExcluirAgrupamentoTarefa)
      .then(response => {
        this.listarGruposPorTarefa(this.state.tarefa);
        this.listarTarefas();
        this.listarGruposTarefasSelecionar(this.state.tarefa);
        this.toast.show({severity:'success', summary: 'Tarefas', detail:'Agrupamento de tarefa desfeito', life: 4000});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Tarefas', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  async acceptRetirarAgrupamentoTarefaPorGrupo() {
    this.setState({openSpinner: true});
    await this.tarefaService.excluirAgrupamento(this.state.codigoExcluirAgrupamentoTarefa, this.state.grupo.codigo)
      .then(response => {
        this.consultarGrupoPosCadastro(this.state.grupo);
        this.listarTarefasSemGrupo(this.state.grupo);
        this.toast.show({severity:'success', summary: 'Tarefas', detail:'Tarefa retirada do Grupo', life: 4000});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Tarefas', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  acoesTarefasPorGrupo(rowData) {
    return(
      <React.Fragment>
        <Button icon="fa fa-solid fa-trash" className="p-button-rounded p-button-text"
                onClick={() => this.confirmaExclusaoAgrupamentoTarefaPorGrupo(rowData)}
                tooltip="Retirar Tarefa"
                tooltipOptions={{position: 'top'}}/>
      </React.Fragment>

    );
  }

  async associarGrupoTarefa(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }

    this.setState(state);
  }

  renderFooterAssosciarGrupoTarefa(name) {
    return (
        <div>
            <Button label="Fechar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  consultarTarefa = async (tarefa) => {
    await this.tarefaService.consultar(tarefa.codigo)
      .then(response => {
        this.setState({tarefa: response.data});
        this.setState({nomeTarefa: response.data.titulo});
        this.setState({usuariosTarefa: response.data.responseveis});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Tarefas', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarGrupos = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.grupoTarefaService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({grupos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Grupos de Tarefas', detail:`${this.state.detail}`, life: 4000});
      })
  }

  acoesGrupos(rowData) {
    return(
      <React.Fragment>
        <Button icon="fa-brands fa-stack-overflow" className="p-button-rounded p-button-text" 
                onClick={() => this.consultarTarefasGrupo(rowData)}
                tooltip="Tarefas" 
                tooltipOptions={{position: 'top'}} />
        &nbsp;
        <Button icon="fa fa-solid fa-pen" className="p-button-rounded p-button-text" 
                onClick={() => this.consultarGrupo(rowData)}
                tooltip="Editar Motivo" 
                tooltipOptions={{position: 'top'}} />
        &nbsp;
        <Button icon="fa fa-solid fa-trash" className="p-button-rounded p-button-text"
                onClick={() => this.confirmaExclusao(rowData)} 
                tooltip="Excluir Motivo" 
                tooltipOptions={{position: 'top'}}/>
      </React.Fragment>
    );
  }

  async consultarTarefasGrupo(grupo) {
    this.setState({openSpinner: true});
    await this.grupoTarefaService.consultarGrupo(grupo.codigo)
      .then(response => {
        this.setState({grupo: response.data});
        this.setState({nome: response.data.nome});
        this.setState({tarefasGrupos: response.data.tarefas});
        this.listarTarefasSemGrupo(grupo);
        this.tarefasPorGrupo('modalTarefasPorGrupo');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Grupos de Tarefas', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  async consultarTarefasGrupoPosCadastro(grupo) {
    await this.grupoTarefaService.consultarGrupo(grupo.codigo)
      .then(response => {
        this.setState({grupo: response.data});
        this.setState({nome: response.data.nome});
        this.setState({tarefasGrupos: response.data.tarefas});
        this.listarTarefasSemGrupo(grupo);
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Grupos de Tarefas', detail:`${this.state.detail}`, life: 4000});
      });
  }

  tarefasPorGrupo(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  renderFooterGrupo(name) {
    return (
        <div>
            <Button label="Cadastrar" 
                    className="p-button-primary p-button-text"
                    onClick={this.cadastrarGrupo}/> 
            &nbsp;
            <Button label="Cancelar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  renderFooterGrupoAlterar(name) {
    return (
        <div>
            <Button label="Alterar" 
                    className="p-button-primary p-button-text"
                    onClick={this.cadastrarGrupo}/> 
            &nbsp;
            <Button label="Cancelar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  renderFooterTarefa(name) {
    return (
        <div>
            <Button label="Cadastrar" 
                    className="p-button-primary p-button-text"
                    onClick={this.cadastrarTarefa}/> 
            &nbsp;
            <Button label="Cancelar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  renderFooterCadastrarUsuario(name) {
    return (
        <div>
            &nbsp;
            <Button label="Fechar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  async novoUsuario(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState({usuario: null});
    this.setState(state);
  }

  novaTarefa(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState({nomeTarefa: ''});
    this.setState({prazo: ''});
    this.setState({pontuacao: ''});
    this.setState({tarefa: null});
    this.setState(state);
  }

  cadastrarTarefa = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(this.state.nomeTarefa == '') {
      this.toast.show({severity:'error', summary: 'Tarefas', detail:'O título da tarefa é obrigatório', life: 5000});
      return;
    }

    if(this.state.tempo == null) {
      this.toast.show({severity:'error', summary: 'Tarefas', detail:'O Tempo da Tarefa é obrigatório', life: 5000});
      return;
    }

    if(this.state.prazo == '') {
      this.toast.show({severity:'error', summary: 'Tarefas', detail:'O Prazo da terefa é obrigatório', life: 5000});
      return;
    }

    if(this.state.pontuacao == '') {
      this.toast.show({severity:'error', summary: 'Tarefas', detail:'A Pontação é obrigatória', life: 5000});
      return;
    }

    var tempo = '';
    if(this.state.tempo.codigo == 'Progressiva') {
      tempo = 'P';
    } else {
      tempo = 'R';
    }

    const tarefa = {
      empresa: usuarioLogado.empresa,
      usuario: usuarioLogado,
      titulo: this.state.nomeTarefa,
      prazo: this.state.prazo,
      tempo: tempo,
      pontuacao: this.state.pontuacao
    }

    this.setState({openSpinner: true});
    await this.tarefaService.cadastrar(tarefa)
      .then(response => {
        this.listarTarefas();
        this.toast.show({severity:'success', summary: 'Tarefas', detail:'Tarefa cadastrada com sucesso!', life: 5000});
        this.fecharModal('modalTarefa');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Grupos de Tarefas', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  fecharModal(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  abrirModalCadastro(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.limparCampos();
    this.setState(state);
  }

  abrirModalAlterar(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  limparCampos() {
    this.setState({grupo: null});
    this.setState({nome: ''});
  }

  cadastrarGrupo = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Grupos de Tarefas', detail:'O nome do grupo de tarefa é obrigatório', life: 4000});
      return;
    }

    const grupo = {
      empresa: usuarioLogado.empresa,
      nome: this.state.nome,
      usuario: usuarioLogado
    }
    this.setState({openSpinner: true});
    await this.grupoTarefaService.cadastrar(grupo)
      .then(response => {
        this.listarGrupos();
        this.toast.show({severity:'success', summary: 'Grupos de Tarefas', detail:'Grupo de Tarefa cadastrado com sucesso', life: 4000});
        this.fecharModal('modalGrupo');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Grupos de Tarefas', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  async consultarGrupo(grupo) {
    this.setState({openSpinner: true});
    await this.grupoTarefaService.consultarGrupo(grupo.codigo)
      .then(response => {
        this.setState({grupo: response.data});
        this.setState({codigo: response.data.codigo});
        this.setState({nome: response.data.nome});
        this.setState({status: response.data.snAtivo});
        this.abrirModalAlterar('modalGrupoAlterar');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Grupos de Tarefas', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  async consultarGrupoPosCadastro(grupo) {
    await this.grupoTarefaService.consultarGrupo(grupo.codigo)
      .then(response => {
        this.setState({grupo: response.data});
        this.setState({codigo: response.data.codigo});
        this.setState({nome: response.data.nome});
        this.setState({status: response.data.snAtivo});
        this.setState({tarefasGrupos: response.data.tarefas});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Grupos de Tarefas', detail:`${this.state.detail}`, life: 4000});
      });
  }

  listarTarefas = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.tarefaService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({tarefas: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Grupos de Tarefas', detail:`${this.state.detail}`, life: 4000});
      })
  }

  acoesTarefas(rowData) {
    return(
      <React.Fragment>
        <Button icon="fa fa-solid fa-pen" className="p-button-rounded p-button-text" 
                tooltip="Editar" 
                onClick={() => this.editarTarefa(rowData)}
                tooltipOptions={{position: 'top'}} />
        &nbsp;
        <Button icon="fa fa-solid fa-trash" className="p-button-rounded p-button-text"
                onClick={() => this.confirmaExclusaoTarefa(rowData)}
                tooltip="Excluir Tarefa"
                tooltipOptions={{position: 'top'}}/>
      </React.Fragment>
    );
  }

  confirmaExclusaoTarefa(tarefa) {
    this.setState({codigoTarefa: tarefa.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir a tarefa selecionada?',
        header: 'Exclusão de Tarefa',
        icon: 'pi pi-question-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirTarefa,
        reject: this.reject
    });
  }

  async acceptExcluirTarefa() {
    await this.excluirTarefa();
  }

  excluirTarefa = async () => {
    this.setState({openSpinner: true});
    await this.tarefaService.excluir(this.state.codigoTarefa)
      .then(response => {
        this.listarTarefas();
        this.toast.show({severity:'success', summary: 'Tarefas', detail:'Tarefa excluída com sucesso!', life: 4000});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Tarefas', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  acoesUsuariosDesignados(rowData) {
    var responsaveis = rowData.responsaveis.length;
    var exibe = 'none';
    var adicionar = 'none';
    if(responsaveis > 0) {
      exibe = 'block';
      adicionar = 'none';
    } else {
      exibe = 'none';
      adicionar = 'block';
    }
    return(
      <React.Fragment>
        <a onClick={() => this.listarUsuarios(rowData)}
           title="Clique aqui para ver os usuários designados para esta tarefa"
           style={{cursor: 'pointer', display: `${exibe}`, color: 'blue', alignItems: 'center'}}>{responsaveis}</a>
        <a onClick={() => this.listarUsuarios(rowData)}
           title="Clique aqui para adicionar usuários que ficarão responnsáveis pela tarefa"
           style={{cursor: 'pointer', display: `${adicionar}`, color: 'blue', alignItems: 'center'}}>Adicionar</a>
      </React.Fragment>
    );
  }

  acoesGruposAssociar(rowData) {
    return(
      <React.Fragment>
        <a onClick={() => this.consultarGruposTarefa(rowData)}
           title="Grupos da Tarefa"
           style={{cursor: 'pointer', color: 'blue', alignItems: 'center'}}>Consultar</a>
      </React.Fragment>
    );
  }

  async editarTarefa(tarefa) {
    this.setState({openSpinner: true});
    await this.tarefaService.consultar(tarefa.codigo)
      .then(response => {
        this.setState({tarefa: response.data});
        this.setState({codigoTarefa: response.data.codigo});
        this.setState({nomeTarefa: response.data.titulo});
        this.setState({prazo: response.data.prazo});
        this.setState({pontuacao: response.data.pontuacao});
        if(response.data.snAtivo == 'ATIVO') {
          this.setState({statusTarefa: {
            codigo: 'ATIVO',
            nome: 'ATIVO'
          }})
        } else {
          this.setState({statusTarefa: {
            codigo: 'INATIVO',
            nome: 'INATIVO'
          }})
        };
        if(response.data.tempo == 'Progressiva') {
          this.setState({tempo: {
            codigo: 'Progressiva',
            nome: 'Progressiva'
          }})
        } else {
          this.setState({tempo: {
            codigo: 'Regressiva',
            nome: 'Regressiva'
          }})
        }
        this.abrirModalAlterar('modalAlterarTarefa');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Grupos de Tarefas', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  abrirModalAlterar(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  renderFooterAlterarTarefa(name) {
    return (
        <div>
            <Button label="Alterar" 
                    className="p-button-primary p-button-text"
                    onClick={this.alterarTarefa}/> 
            &nbsp;
            <Button label="Cancelar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  alterarTarefa = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(this.state.nometarefa == '') {
      this.toast.show({severity:'error', summary: 'Tarefa', detail:'O título da tarefa é obrigatório', life: 4000});
      return;
    }

    if(this.state.tempo == null) {
      this.toast.show({severity:'error', summary: 'Tarefa', detail:'O Tempo da Tarefa é obrigatório', life: 4000});
      return;
    }

    if(this.state.prazo == '') {
      this.toast.show({severity:'error', summary: 'Tarefa', detail:'O prazo da tarefa é obrigatório', life: 4000});
      return;
    }

    if(this.state.pontuacao == '') {
      this.toast.show({severity:'error', summary: 'Tarefa', detail:'A pontuação da tarefa é obrigatória', life: 4000});
      return;
    }

    var ativo = '';
    if(this.state.statusTarefa.codigo == 'ATIVO') {
      ativo = 'S';
    } else {
      ativo = 'N';
    }

    var tempo = '';
    if(this.state.tempo.codigo == 'Progressiva') {
      tempo = 'P';
    } else {
      tempo = 'R';
    }

    const tarefa = {
      codigo: this.state.tarefa.codigo,
      dataRegistro: this.state.tarefa.dataRegistro,
      empresa: usuarioLogado.empresa,
      usuario: usuarioLogado,
      titulo: this.state.nomeTarefa,
      prazo: this.state.prazo,
      tempo: tempo,
      pontuacao: this.state.pontuacao,
      snAtivo: ativo,
    }
    this.setState({openSpinner: true});
    await this.tarefaService.alterar(tarefa)
      .then(response => {
        this.listarTarefas();
        this.toast.show({severity:'success', summary: 'Tarefa', detail:'Tarefa alterada com sucesso!', life: 4000});
        this.fecharModal('modalAlterarTarefa');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Tarefas', detail:`${this.state.detail}`, life: 4000});
      })
      this.setState({openSpinner: false});
  }

  async componentDidMount() {
    this.setState({openSpinner: true});
    await this.listarGrupos();
    await this.listarTarefas();
    this.setState({openSpinner: false});
  }

  adicionarUsuarioTarefa = async () => {
    if(this.state.usuario == null) {
      this.toast.show({severity:'error', summary: 'Tarefas', detail:'Informe o usuário', life: 4000});
      return;
    }

    if(this.state.grupoTarefa == null) {
      this.toast.show({severity:'error', summary: 'Tarefas', detail:'Informe o Grupo de Tarefa', life: 4000});
      return;
    }

    this.setState({openSpinner: true});
    await this.tarefaService.consultarAgrupamento(this.state.tarefa.codigo,this.state.grupoTarefa.codigo)
      .then(response => {
        const usuarioTarefa = {
          agrupamento: {
            grupo: this.state.grupoTarefa,
            tarefa: this.state.tarefa
          },
          usuario: this.state.usuario
        }
        this.tarefaService.adicionarUsuarioTarefa(usuarioTarefa)
          .then(response => {
            this.listarUsuariosPorTarefa(this.state.tarefa);
            this.listarTarefas();
            this.setState({usuario: null});
            this.setState({grupoTarefa: null});
            this.toast.show({severity:'success', summary: 'Tarefas', detail:'Usuário adicionado a tarefa com sucesso!', life: 4000});
          }).catch(error => {
            this.toast.show({severity:'error', summary: 'Tarefas', detail:'Erro ao adicionar usuário', life: 4000});
          })
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Tarefas', detail:'Erro ao consultar agrupamento de tarefas', life: 4000});
      })
      this.setState({openSpinner: false});
  }

  listarUsuariosPorTarefa = async (tarefa) => {
    await this.tarefaService.listarUsuariosPorTarefa(tarefa.codigo)
      .then(response => {
        this.setState({usuariosTarefa: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Tarefas', detail:`${this.state.detail}`, life: 4000});
      })
  }

  confirmaExclusaoUsuarioTarefa(usuarioTarefa) {
    this.setState({codigoUsuarioTarefa: usuarioTarefa.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir o usuário deta tarefa?',
        header: 'Excluir usuário da tarefa',
        icon: 'pi pi-question-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirUsuario,
        reject: this.reject
    });
  }

  acceptExcluirUsuario() {
    this.excluirUsuarioTarefa();
  }

  excluirUsuarioTarefa = async () => {
    this.setState({openSpinner: true});
    await this.tarefaService.excluirUsuarioTarefa(this.state.codigoUsuarioTarefa)
      .then(response => {
        this.listarUsuariosPorTarefa(this.state.tarefa);
        this.listarTarefas();
        this.toast.show({severity:'success', summary: 'Tarefas', detail:'Usuário excluído com sucesso', life: 4000});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Tarefas', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  acoesUsuariosTarefa(rowData) {
    return(
      <React.Fragment>
        <Button icon="fa fa-solid fa-trash" className="p-button-rounded p-button-text"
                onClick={() => this.confirmaExclusaoUsuarioTarefa(rowData)}
                tooltip="Excluir Usuário"
                tooltipOptions={{position: 'top'}}/>
      </React.Fragment>
    );
  }

  render() {
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.openSpinner}>
          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
        </Backdrop>
        <div className="content-wrapper">
          <div className="container-fluid">
            <section className="content-header">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card card-primary card-outline">
                      <div className="card-header">
                        <h3 className="card-title">
                          <i className="pi pi-wallet"></i>
                          <span> Grupos de Tarefas</span>
                        </h3>  
                      </div>
                      <TabView className="tabview-custom">
                        <TabPanel header="Grupos">
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <button type="button" className="btn btn-primary bg-gradient-primary" 
                                      onClick={() => this.abrirModalCadastro('modalGrupo')}
                                      data-toggle="modal" 
                                      data-target="#modal-default">
                                      <i className="fas fa-plus"></i> Adicionar
                              </button>
                            </div>
                            <DataTable value={this.state.grupos}  paginator responsiveLayout="scroll"
                              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                              currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" emptyMessage=" " rows={10}>
                              <Column field="nome" header="Nome"></Column>
                              <Column body={this.acoesGrupos} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                            </DataTable>
                          </div>
                        </div>
                        </TabPanel>
                        <TabPanel header="Atividades">
                          <div className="row">
                            <div className="col-sm-12">
                              <div className="form-group">
                                <button type="button" className="btn btn-primary bg-gradient-primary" 
                                        onClick={() => this.novaTarefa('modalTarefa')}
                                        data-toggle="modal" 
                                        data-target="#modal-default">
                                        <i className="fas fa-plus"></i> Adicionar
                                </button>
                              </div>
                              <DataTable value={this.state.tarefas}  paginator responsiveLayout="scroll"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" emptyMessage=" " rows={10}>
                                <Column field="titulo" header="Nome"></Column>
                                <Column field="tempo" header="Tempo"></Column>
                                <Column field="prazo" header="Prazo"></Column>
                                <Column field="pontuacao" header="Pontuação"></Column>
                                <Column field="snAtivo" header="Status"></Column>
                                <Column body={this.acoesGruposAssociar} exportable={false} style={{ minWidth: '8rem' }}header="Grupos"></Column>
                                <Column body={this.acoesUsuariosDesignados} exportable={false} style={{ minWidth: '8rem' }}header="Designados"></Column>
                                <Column body={this.acoesTarefas} exportable={false} style={{ minWidth: '8rem' }}header="Designados"></Column>
                              </DataTable>
                            </div>
                          </div>
                        </TabPanel>
                      </TabView>
                    </div>
                  </div>
                </div>
              </div>
              {/**Cadastrar Grupo de Tarefas */}
              <Dialog header="Cadastrar novo Grupo de Tarefa"
                        visible={this.state.modalGrupo} 
                        style={{ width: '40vw' }} 
                        footer={this.renderFooterGrupo('modalGrupo')} 
                        onHide={() => this.fecharModal('modalGrupo')}>
                    
                    <div className="p-fluid">
                        <div className="p-field">
                            <label htmlFor="nomeGrupo">Nome</label>
                            <InputText id="nomeGrupo" 
                                      type="text" 
                                      value={this.state.nome}
                                      onChange={e => this.setState({nome: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                    </div>
              </Dialog>
              {/**Alterar Grupo de Tarefas */}
              <Dialog header="Alterar Grupo de Tarefa"
                        visible={this.state.modalGrupoAlterar} 
                        style={{ width: '40vw' }} 
                        footer={this.renderFooterGrupoAlterar('modalGrupoAlterar')} 
                        onHide={() => this.fecharModal('modalGrupoAlterar')}>
                    
                    <div className="p-fluid">
                      <div className="p-field">
                        <label htmlFor="nomeGrupoAlterar">Nome</label>
                        <InputText id="nomeGrupoAlterar" 
                                  type="text" 
                                  value={this.state.nome}
                                  onChange={e => this.setState({nome: e.target.value})}
                                  className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
              </Dialog>
              {/**Exibir Tarefas por Grupo */}
              <Dialog header="Tarefas do Grupo"
                      visible={this.state.modalTarefasPorGrupo} 
                      style={{ width: '40vw' }} 
                      footer={
                        <frameElement>
                          <Button label="Fechar" 
                                  className="p-button-secondary p-button-text"
                                  onClick={() => this.fecharModal('modalTarefasPorGrupo')}/>
                        </frameElement>
                      } 
                      onHide={() => this.fecharModal('modalTarefasPorGrupo')}>
                    
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <label htmlFor="titulo">Grupo: {this.state.nome}</label>
                        </div>
                      </div>
                    </div>
                    <br/>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <label htmlFor="titulo">Adicionar Tarefa</label>
                          <Dropdown value={this.state.tarefaSemGrupo}
                                    options={this.state.tarefasSemGrupo} style={{width: '100%', height: '32px'}}
                                    optionLabel="titulo" 
                                    emptyMessage=" "
                                    filter showClear filterBy="titulo"
                                    onChange={this.onChangeTarefa}
                                    id="grupoTarefaSelecionar"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <br/>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <label htmlFor="titulo">Tarefas</label>
                          <br/>
                          <DataTable value={this.state.tarefasGrupos}  paginator responsiveLayout="scroll"
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" 
                            emptyMessage="Nenhum tarefa cadastrada"
                            size="small"
                            rows={5}>
                            <Column field="titulo" header="Nome"></Column>
                            <Column field="prazo" header="Prazo"></Column>
                            <Column body={this.acoesTarefasPorGrupo} exportable={false} style={{ minWidth: '8rem' }}header="Excluir"></Column>
                          </DataTable>
                        </div>
                      </div>
                    </div>
              </Dialog>
              {/**Cadastrar novas Tarefas */}
              <Dialog header="Cadastrar nova Tarefa"
                        visible={this.state.modalTarefa} 
                        style={{ width: '40vw' }} 
                        footer={this.renderFooterTarefa('modalTarefa')} 
                        onHide={() => this.fecharModal('modalTarefa')}>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="form-group">
                      <label htmlFor="titulo">Título</label>
                      <InputText id="titulo" 
                                type="text" 
                                style={{width: '100%', height: '32px'}} 
                                value={this.state.nomeTarefa}
                                onChange={e => this.setState({nomeTarefa: e.target.value})}
                                className="p-inputtext-sm p-d-block p-mb-1"/>
                  </div>
                </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="form-group">
                      <label htmlFor="tempo">Tempo</label>
                      <Dropdown value={this.state.tempo}
                                options={this.tempo} style={{width: '100%', height: '32px'}}
                                optionLabel="nome" 
                                emptyMessage=" "
                                filter showClear filterBy="nome"
                                onChange={e => this.setState({tempo: e.target.value})}
                                id="tempo"
                                className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="prazo">Prazo</label>
                      <InputText id="prazo" 
                                type="text" 
                                style={{width: '100%', height: '32px'}} 
                                value={this.state.prazo}
                                onChange={e => this.setState({prazo: e.target.value})}
                                className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="pontuacao">Pontuação</label>
                      <InputText id="pontuacao" 
                                type="text" 
                                style={{width: '100%', height: '32px'}} 
                                value={this.state.pontuacao}
                                onChange={e => this.setState({pontuacao: e.target.value})}
                                className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                  </div>
                </div>
              </Dialog>
              {/**Alterar Tarefa */}
              <Dialog header="Alterar Tarefa"
                        visible={this.state.modalAlterarTarefa} 
                        style={{ width: '40vw' }} 
                        footer={this.renderFooterAlterarTarefa('modalAlterarTarefa')} 
                        onHide={() => this.fecharModal('modalAlterarTarefa')}>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="form-group">
                      <label htmlFor="tituloAlterar">Título</label>
                      <InputText id="tituloAlterar" 
                                type="text" 
                                style={{width: '100%', height: '32px'}} 
                                value={this.state.nomeTarefa}
                                onChange={e => this.setState({nomeTarefa: e.target.value})}
                                className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="form-group">
                      <label htmlFor="tempo">Tempo</label>
                      <Dropdown value={this.state.tempo}
                                options={this.tempo} style={{width: '100%', height: '32px'}}
                                optionLabel="nome" 
                                emptyMessage=" "
                                filter showClear filterBy="nome"
                                onChange={e => this.setState({tempo: e.target.value})}
                                id="tempo"
                                className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="prazoAlterar">Prazo</label>
                      <InputText id="prazoAlterar" 
                                type="text" 
                                style={{width: '100%', height: '32px'}} 
                                value={this.state.prazo}
                                onChange={e => this.setState({prazo: e.target.value})}
                                className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="pontuacaoAlterar">Pontuação</label>
                      <InputText id="pontuacaoAlterar" 
                                type="text" 
                                style={{width: '100%', height: '32px'}} 
                                value={this.state.pontuacao}
                                onChange={e => this.setState({pontuacao: e.target.value})}
                                className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="form-group">
                      <label htmlFor="statusTarefaAlterar">Status</label> 
                      <Dropdown value={this.state.statusTarefa}
                                options={this.status} style={{width: '100%', height: '32px'}}
                                optionLabel="nome" 
                                emptyMessage=" "
                                filter showClear filterBy="nome"
                                onChange={e => this.setState({statusTarefa: e.target.value})}
                                id="statusTarefaAlterar"
                                className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                  </div>
                </div>
              </Dialog>
              {/**Adicionar Tarefa ao Grupo */}
              <Dialog header="Associar Tarefa ao Grupo"
                        visible={this.state.modalAssociarGrupoTarefa} 
                        style={{ width: '40vw' }} 
                        footer={this.renderFooterAssosciarGrupoTarefa('modalAssociarGrupoTarefa')} 
                        onHide={() => this.fecharModal('modalAssociarGrupoTarefa')}>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <label htmlFor="prazo">Tarefa: {this.state.nomeTarefa}</label>
                        </div>
                      </div>
                    </div>
                    <br/>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <label htmlFor="grupoTarefaSelecionar">Associar a Grupo</label>
                          <Dropdown value={this.state.grupoTarefa} 
                                    options={this.state.gruposTarefasSelecionar} style={{width: '100%', height: '32px'}}
                                    optionLabel="nome" 
                                    emptyMessage=" "
                                    filter showClear filterBy="nome"
                                    onChange={this.onChangeGrupoTarefa}
                                    id="grupoTarefaSelecionar"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <DataTable value={this.state.gruposTarefas} 
                                     size="Small"
                                     emptyMessage="Nenhum grupo associado ainda">
                            <Column field="nome" header="Grupos Associados"></Column>
                            <Column body={this.acoesAgrupamentoTarefa} exportable={false} style={{ minWidth: '8rem' }}header="Excluir"></Column>
                          </DataTable>
                        </div>
                      </div>
                    </div>
              </Dialog>
              {/**Cadastrar Usuários */}
              <Dialog header="Inserir Responsável da Tarefa"
                        visible={this.state.modalCadastroUsuarios} 
                        style={{ width: '40vw' }} 
                        footer={this.renderFooterCadastrarUsuario('modalCadastroUsuarios')} 
                        onHide={() => this.fecharModal('modalCadastroUsuarios')}>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <label htmlFor="prazo">Tarefa: {this.state.nomeTarefa}</label>
                        </div>
                      </div>
                    </div>
                    <br/>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <label htmlFor="prazo">Usuários</label>
                          <Dropdown value={this.state.usuario} 
                                    options={this.state.usuarios} style={{width: '100%', height: '32px'}}
                                    optionLabel="nome" 
                                    emptyMessage=" "
                                    filter showClear filterBy="nome"
                                    onChange={e => this.setState({usuario: e.target.value})}
                                    id="criaOutraTarefa"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <label htmlFor="grupoUsuario">Grupo</label>
                          <Dropdown value={this.state.grupoTarefa}
                                    options={this.state.gruposTarefas} style={{width: '100%', height: '32px'}}
                                    optionLabel="nome"
                                    emptyMessage=" "
                                    filter showClear filterBy="nome"
                                    onChange={e => this.setState({grupoTarefa: e.target.value})}
                                    id="grupoTarefaSelecionarUsuario"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>

                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <a onClick={this.adicionarUsuarioTarefa}
                            title="Adicionar usuário à Tarefa"
                            style={{cursor: 'pointer', color: 'blue', alignItems: 'center'}}>Adicionar</a>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <DataTable value={this.state.usuariosTarefa} 
                                     size="Small"
                                     emptyMessage="Nenhum usuário cadastrado nesta tarefa">
                            <Column field="usuario.nome" header="Usuário"></Column>
                            <Column field="agrupamento.grupo.nome" header="Grupo"></Column>
                            <Column body={this.acoesUsuariosTarefa} exportable={false} style={{ minWidth: '8rem' }}header="Excluir"></Column>
                          </DataTable>
                        </div>
                      </div>
                    </div>
              </Dialog>
            </section>
          </div>
        </div>
      </>
    )
  }
}

GrupoTarefa.contextType = AuthContext;
export default withRouter (GrupoTarefa)